
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class CampaignTemplatesGrid extends Serenity.EntityGrid<CampaignTemplatesRow, any> {
        protected getColumnsKey() { return 'Administration.CampaignTemplates'; }
        protected getDialogType() { return CampaignTemplatesDialog; }
        protected getIdProperty() { return CampaignTemplatesRow.idProperty; }
        protected getInsertPermission() { return CampaignTemplatesRow.insertPermission; }
        protected getLocalTextPrefix() { return CampaignTemplatesRow.localTextPrefix; }
        protected getService() { return CampaignTemplatesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

        }
    }
}